import { useCallback, useMemo } from 'react';
import { type QueryParameterConfig, useQueryParameter } from './useQueryParameter';

export type AssignEncodeValueOptions<T> = {
  newValue?: T;
  object: Record<string, string | string[] | undefined>;
};

export function useAssignQueryParameter<T, K = T>(paramKey: string, config: QueryParameterConfig<T, K>) {
  const value = useQueryParameter(paramKey, config);

  const assignValue = useCallback(
    ({ newValue, object }: AssignEncodeValueOptions<T>): void => {
      object[paramKey] = config.encode(newValue);
    },
    [config, paramKey],
  );

  const resetValue = useCallback(
    (object: Record<string, string | string[] | undefined>): void => {
      object[paramKey] = undefined;
    },
    [paramKey],
  );

  return useMemo(
    () => ({
      assignValue,
      resetValue,
      value,
    }),
    [assignValue, resetValue, value],
  );
}
